import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import INFTProperties, { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { IHatchyPocketCard } from '../Card/IHatchyPocketCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'

export default function HatchyPocketDetail(props: INFDetailFormatted) {
  const { tokenItem } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IHatchyPocketCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => {
        let newProps = {
          key: item.trait_type,
          value: item.value,
          show: true,
          isUrl: false
        }

        if (item.trait_type === 'Shiny') {
          newProps = {
            ...newProps,
            value: detailTokenItem.isShiny === 1 ? 'Yes' : 'No'
          }
        }

        return newProps
      })

      result.push({
        key: 'Sound',
        value: `https://hatchypocket.com/static/sounds/${detailTokenItem.sound}`,
        isAudio: true
      })
    }
    return result
  }

  return (
    <BaseDetail
      {...props}
      description={detailTokenItem ? <div>{detailTokenItem.description}</div> : <></>}
      tokenItemName={detailTokenItem ? `${detailTokenItem.name} - ID: ${detailTokenItem.id}` : ''}
      properites={getNFTProperties()}
    >
      {detailTokenItem ? (
        <img className="pixelated-image" src={detailTokenItem.image} alt={detailTokenItem.name} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
